import { useTranslations } from '~/src/hooks/useTranslations'

const ForgotPasswordTitle = () => {
  const { t } = useTranslations()

  return <span>{t('auth.forgot_password')}</span>
}

export default ForgotPasswordTitle
